import { RouteConfig } from '/@/modules/core/app/helpers/RouteConfig';

export class CheckoutRouteConfig extends RouteConfig {}
